const $         = require('jquery');
const _         = require('underscore');
const { icon }  = require('@fortawesome/fontawesome-svg-core');
const tippy     = require('tippy.js/dist/tippy-bundle.umd.js');
const tpl       = require('../util/template');
const eventer   = require('../util/eventer');

const PADDING = 4;
const faIconOpts = { classes: ['fa-icon'] };
const fa = {
  angleLeft: require('@fortawesome/pro-light-svg-icons/faAngleLeft').definition,
  angleRight: require('@fortawesome/pro-light-svg-icons/faAngleRight').definition
};

const measure = $('<span id="pagination-input-measure"></span>');
const measureText = _.memoize((text, input) => {
  measure.css('font-size', parseInt(input.css('font-size')));
  measure.insertBefore(input);
  return Math.ceil(measure.text(text).width());
}, (text, input) => text + input[0].className);

function Pagination(opts) {
  const api = eventer({});

  let current = -1;
  let total = Infinity;
  let labels = null;

  let elem = $(`
    <pagination class="wrfont ${tpl.cls({ 'hide-buttons': opts.hide_buttons })}">
      <button class="toolbar-btn prev-page" data-tippy-content="${opts.prev_title || 'Previous'}">
        ${icon(fa.angleLeft, faIconOpts).html}
      </button>
      <div class="pginfo indexes">
        <input class="idx" val=""></input>/
        <div class="num"></div>
      </div>
      <div class="pginfo labels">
        <input class="lbl" val=""></input>
        <div class="all"></div>
      </div>
      <button class="toolbar-btn next-page" data-tippy-content="${opts.next_title || 'Next'}">
        ${icon(fa.angleRight, faIconOpts).html}
      </button>
    </pagination>
  `);

  const currIdx = elem.find('input.idx');
  const currLbl = elem.find('input.lbl');
  const numPages = elem.find('div.num');
  const allPages = elem.find('div.all');

  elem.find('.prev-page').click(() => goPrev(true));
  elem.find('.next-page').click(() => goNext(true));

  currIdx.on('input', () => resizeInput(currIdx));
  currIdx.on('click', () => { currIdx[0].select(); });

  currLbl.on('input', () => resizeInput(currLbl));
  currLbl.on('click', () => { currLbl[0].select(); });

  $(window).on('resize', _.debounce(() => {
    resizeInput(currIdx);
    resizeInput(currLbl);
  }, 100));

  currIdx.on('blur', () => {
    let idx = parseInt(currentRange().shift());
    let indexes = isNaN(idx) ? current : idx;
    setCurrent({ indexes, emit: true });
  });

  currLbl.on('blur', () => {
    if (!labels) return
    let name = currLbl.val();
    let index = labels.indexOf(name);
    if (index >= 0) {
      setCurrent({ indexes: index + 1, emit: true });
    } else {
      let indexes = [parseInt(name)];
      if (isNaN(indexes[0])) {
        currLbl.val(currLbl.attr('data-val'));
      } else {
        setCurrent({ indexes, emit: true });
      }
    }
  });

  currIdx.on('keydown', e => {
    e.stopImmediatePropagation();
    // Blur on enter
    if (e.keyCode == 13) currIdx.blur();
    // Allow: backspace, delete, tab, escape, enter
    if ([46, 8, 9, 27, 13].indexOf(e.keyCode) != -1 ||
       // Allow: Ctrl+A|C|X
      ((e.ctrlKey || e.metaKey) && [65, 67, 88].indexOf(e.keyCode) != -1) ||
       // Allow: end, home, arrow keys, insert
      ([35, 36, 37, 38, 39, 40, 45].indexOf(e.keyCode) != -1)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });

  currLbl.on('keydown', e => {
    e.stopImmediatePropagation();
    // Blur on enter
    if (e.keyCode == 13) currLbl.blur();
  });

  function resizeInput(input) {
    const text = input.val()
      .replace(/[0-9]/g, '0')
      .replace(/[a-z]/g, 'A');
    const width = measureText(text, input) + PADDING;
    if (input.data('width') != width) {
      input.data('width', width);
      input.width(width);
    }
  }

  function clipIdx(idx) {
    return Math.min(Math.max(parseInt(idx), 1), total);
  }

  function currentRange() {
    return currIdx.val().split(/[^0-9]/g);
  }

  function goPrev(emit) {
    const lidx = parseInt(currentRange().shift());
    if (lidx > 1) setCurrent({ indexes: lidx - 1, emit });
  }

  function goNext(emit) {
    const ridx = parseInt(currentRange().pop());
    if (ridx < total) setCurrent({ indexes: ridx + 1, emit });
  }

  function setCurrent({ indexes, emit }) {
    if (!Array.isArray(indexes)) indexes = [indexes];
    indexes = _.uniq(indexes.map(clipIdx));
    current = indexes[0];

    let indexVal = `${indexes[0]}`;
    if (indexes[1]) indexVal += `-${indexes[1]}`;
    currIdx.val(indexVal);
    resizeInput(currIdx);

    if (labels) {
      let labelVal = `${labels[indexes[0] - 1]}`;
      if (indexes[1]) labelVal += `-${labels[indexes[1] - 1]}`;
      currLbl.attr('data-val', labelVal);
      currLbl.val(labelVal);
      allPages.text(`(${indexVal} / ${total})`);
      resizeInput(currLbl);
    }

    elem.removeClass('first last');
    if (currentRange().shift() <= 1) {
      elem.addClass('first');
    }
    if (currentRange().pop() >= total) {
      elem.addClass('last');
    }

    if (emit) {
      api.trigger('paginate', [current]);
    }
  }

  function setLabels(arr) {
    if (arr && arr.length) {
      labels = arr.slice();
      elem.addClass('has-labels');
    }
  }

  function setTotal(num) {
    total = num;
    elem.find('.pginfo').attr('data-num', total.toString().length);
    numPages.text(total);
  }

  function init(opts) {
    elem.appendTo(opts.container);
    elem.find('button[data-tippy-content]').each((idx, el) => {
      tippy(el, { placement: 'bottom' });
    });
    setTotal(opts.total);
    setLabels(opts.labels);
    setCurrent({ indexes: opts.current });
    return api;
  }

  api.init = init;
  api.goPrev = () => goPrev(true);
  api.goNext = () => goNext(true);
  api.setLabels = labels => {
    setLabels(labels);
    setCurrent({ indexes: current });
  };

  Object.defineProperty(api, 'current', {
    get() { return current; },
    set(index) { setCurrent({ indexes: index }); }
  });

  return api;
}

module.exports = Pagination;
